// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectConfiguration_PotentialConfigsQueryVariables = Types.Exact<{
  structureId: Types.Scalars['ID']['input'];
}>;


export type SelectConfiguration_PotentialConfigsQuery = { __typename?: 'Query', checkoutConfigs: { __typename?: 'CheckoutConfigsPage', entities: Array<{ __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], mhExteriorOptionNames: Array<string>, mhInteriorOptionNames: Array<string>, aduExteriorOptionNames: Array<string>, aduInteriorOptionNames: Array<string>, createdBy?: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined }> } };

export type SelectConfiguration_SelectedConfigQueryVariables = Types.Exact<{
  configId: Types.Scalars['ID']['input'];
}>;


export type SelectConfiguration_SelectedConfigQuery = { __typename?: 'Query', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'DesignPackage', id: string }
      | { __typename?: 'ProductOffering', id: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } };

export type SelectConfiguration_PotentialCheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], mhExteriorOptionNames: Array<string>, mhInteriorOptionNames: Array<string>, aduExteriorOptionNames: Array<string>, aduInteriorOptionNames: Array<string>, createdBy?: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, name: string } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined };

export type SelectConfiguration_InternalUserFragment = { __typename?: 'InternalUser', id: string, name: string, avatar: string };

export type SelectConfiguration_SelectedConfig_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string }
    | { __typename?: 'PlanPackage', id: string }
    | { __typename?: 'DesignPackage', id: string }
    | { __typename?: 'ProductOffering', id: string }
   | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export const SelectConfiguration_InternalUserFragmentDoc = gql`
    fragment SelectConfiguration_InternalUser on InternalUser {
  id
  name
  avatar
}
    `;
export const SelectConfiguration_PotentialCheckoutConfigFragmentDoc = gql`
    fragment SelectConfiguration_PotentialCheckoutConfig on CheckoutConfig {
  id
  name
  updatedAt
  createdBy {
    id
    internalUser {
      ...SelectConfiguration_InternalUser
    }
  }
  productOffering {
    ...Named
  }
  aggregateVersion {
    id
    displayVersion
  }
  aduProductOffering {
    ...Named
  }
  aduAggregateVersion {
    id
    displayVersion
  }
  mhExteriorOptionNames
  mhInteriorOptionNames
  aduExteriorOptionNames
  aduInteriorOptionNames
}
    ${SelectConfiguration_InternalUserFragmentDoc}
${NamedFragmentDoc}`;
export const SelectConfiguration_SelectedConfig_CheckoutConfigFragmentDoc = gql`
    fragment SelectConfiguration_SelectedConfig_CheckoutConfig on CheckoutConfig {
  id
  readyPlan {
    id
  }
  readyPlanOptions {
    id
  }
}
    `;
export const SelectConfiguration_PotentialConfigsDocument = gql`
    query SelectConfiguration_PotentialConfigs($structureId: ID!) {
  checkoutConfigs(
    filter: {structure: [$structureId], status: [RESERVED]}
    order: {reservedAt: DESC}
  ) {
    entities {
      ...SelectConfiguration_PotentialCheckoutConfig
    }
  }
}
    ${SelectConfiguration_PotentialCheckoutConfigFragmentDoc}`;

/**
 * __useSelectConfiguration_PotentialConfigsQuery__
 *
 * To run a query within a React component, call `useSelectConfiguration_PotentialConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectConfiguration_PotentialConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectConfiguration_PotentialConfigsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useSelectConfiguration_PotentialConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables> & ({ variables: SelectConfiguration_PotentialConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>(SelectConfiguration_PotentialConfigsDocument, options);
      }
export function useSelectConfiguration_PotentialConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>(SelectConfiguration_PotentialConfigsDocument, options);
        }
// @ts-ignore
export function useSelectConfiguration_PotentialConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>;
export function useSelectConfiguration_PotentialConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_PotentialConfigsQuery | undefined, SelectConfiguration_PotentialConfigsQueryVariables>;
export function useSelectConfiguration_PotentialConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>(SelectConfiguration_PotentialConfigsDocument, options);
        }
export type SelectConfiguration_PotentialConfigsQueryHookResult = ReturnType<typeof useSelectConfiguration_PotentialConfigsQuery>;
export type SelectConfiguration_PotentialConfigsLazyQueryHookResult = ReturnType<typeof useSelectConfiguration_PotentialConfigsLazyQuery>;
export type SelectConfiguration_PotentialConfigsSuspenseQueryHookResult = ReturnType<typeof useSelectConfiguration_PotentialConfigsSuspenseQuery>;
export type SelectConfiguration_PotentialConfigsQueryResult = ApolloReactCommon.QueryResult<SelectConfiguration_PotentialConfigsQuery, SelectConfiguration_PotentialConfigsQueryVariables>;
export const SelectConfiguration_SelectedConfigDocument = gql`
    query SelectConfiguration_SelectedConfig($configId: ID!) {
  checkoutConfig(id: $configId) {
    ...SelectConfiguration_SelectedConfig_CheckoutConfig
  }
}
    ${SelectConfiguration_SelectedConfig_CheckoutConfigFragmentDoc}`;

/**
 * __useSelectConfiguration_SelectedConfigQuery__
 *
 * To run a query within a React component, call `useSelectConfiguration_SelectedConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectConfiguration_SelectedConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectConfiguration_SelectedConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useSelectConfiguration_SelectedConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables> & ({ variables: SelectConfiguration_SelectedConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>(SelectConfiguration_SelectedConfigDocument, options);
      }
export function useSelectConfiguration_SelectedConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>(SelectConfiguration_SelectedConfigDocument, options);
        }
// @ts-ignore
export function useSelectConfiguration_SelectedConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>;
export function useSelectConfiguration_SelectedConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfiguration_SelectedConfigQuery | undefined, SelectConfiguration_SelectedConfigQueryVariables>;
export function useSelectConfiguration_SelectedConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>(SelectConfiguration_SelectedConfigDocument, options);
        }
export type SelectConfiguration_SelectedConfigQueryHookResult = ReturnType<typeof useSelectConfiguration_SelectedConfigQuery>;
export type SelectConfiguration_SelectedConfigLazyQueryHookResult = ReturnType<typeof useSelectConfiguration_SelectedConfigLazyQuery>;
export type SelectConfiguration_SelectedConfigSuspenseQueryHookResult = ReturnType<typeof useSelectConfiguration_SelectedConfigSuspenseQuery>;
export type SelectConfiguration_SelectedConfigQueryResult = ApolloReactCommon.QueryResult<SelectConfiguration_SelectedConfigQuery, SelectConfiguration_SelectedConfigQueryVariables>;